<template>
  <div class="service" style="layout-grid:15.6000pt;">
    <h3 align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:等线;mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:16.0000pt;mso-font-kerning:1.0000pt;">
          <font face="等线">广联达</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:等线;mso-bidi-font-family:'Times New Roman';
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:16.0000pt;
mso-font-kerning:1.0000pt;">&nbsp;</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:等线;mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:16.0000pt;mso-font-kerning:1.0000pt;">
          <font face="等线">&#8226; 斑马进度产品 隐私政策</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:等线;mso-bidi-font-family:'Times New Roman';
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:16.0000pt;
mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h3>
    <p class=MsoNormal align=right style="text-align:right;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">本版更新时间：</font>
        <font face="宋体">2024年08月16日</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal align=center style="mso-pagination:widow-orphan;text-align:center;">
      <hr width="100%" align=center>
    </p>
    <h4 align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:14.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">前言</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:14.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h4>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">广联达科技股份有限公司（以下统称</font>
        <font face="宋体">
          “广联达”或“我们”）一向承诺保护使用广联达斑马进度产品和服务（以下统称“广联达服务”）之用户（以下统称“用户”或“您”）的个人信息和隐私安全。您在使用我们的服务时，我们可能会收集和使用您的相关个人信息。我们特制定《广联达斑马进度产品隐私政策》（下称“本政策”/“本隐私政策”），帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。我们希望通过本“隐私政策”向您说明我们在收集和使用您相关个人信息时对应的处理规则等相关事宜，以便更好地保障您的权益。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">本政策适用于我们提供的所有广联达服务。当您使用我们任何单项服务时，您同意接受本政策以及我们在该单项服务中发出的特定个人信息保护类政策条款（下列称</font>
        <font face="宋体">
          “特定条款”）的保护，在此情况下特定条款与本政策条款同时对您产生效力。如特定条款与本政策条款存在同类条款的不一致约定，则在特定条款约束范围内应以特定条款为准。如我们提供的某一单项服务不适用本政策的，该服务中会以适当方式明示排除适用本政策。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">在使用各项广联达服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体</font>
        <font face="宋体">
          /粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如果您不同意本政策的内容，将可能导致我们的产品和服务无法正常运行，或者无法达到我们拟达到的服务效果，您应立即停止访问/使用我们的产品与/或服务。
        </font>
      </span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:10.5000pt;mso-font-kerning:1.0000pt;">
          <font face="宋体">您使用或继续使用广联达服务，都表示您同意我们按照本政策（包括更新版本）收集、使用、储存、分享、转让和披露您的个人信息。</font>
        </span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">在阅读完本政策后，如您对本政策或与本政策相关的事宜有任何问题，您可通过本政策</font>
        <font face="宋体">“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答及处理。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h4 align=center style="text-align:center;"><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:14.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">目录</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:14.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h4>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">一、我们如何收集和使用个人信息</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">二、我们如何使用</font>
      </span><span style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">COOKIESS</span><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">或同类技术</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">三、我们可能共享、公开的个人信息</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">四、我们如何储存和保护个人信息</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">五、如何管理您的个人信息</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">六、第三方服务</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">七、我们对未成年人的政策</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">八、通知和修订</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">九、适用法律与争议解决</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoHeading8 style="margin-right:0.0000pt;margin-left:0.0000pt;mso-para-margin-top:0.0000gd;
mso-para-margin-bottom:0.0000gd;"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
font-size:12.0000pt;mso-font-kerning:1.0000pt;">
        <font face="黑体">十、如何联系我们</font>
      </span><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">一、我们如何收集和使用个人信息</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">（一）我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息：</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l13 level1 lfo1;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您在使用我们服务时主动提供的信息</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:42.2500pt;mso-para-margin-left:0.0000gd;text-indent:-21.2500pt;
mso-char-indent-count:0.0000;line-height:150%;mso-list:l5 level1 lfo2;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您在注册账号或使用我们的服务时，向我们提供的相关个人信息，例如您在注册广联达账户时所填写的电话号码、电子邮件等；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:42.2500pt;mso-para-margin-left:0.0000gd;text-indent:-21.2500pt;
mso-char-indent-count:0.0000;line-height:150%;mso-list:l5 level1 lfo2;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传的信息；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:42.2500pt;mso-para-margin-left:0.0000gd;text-indent:-21.2500pt;
mso-char-indent-count:0.0000;line-height:150%;mso-list:l5 level1 lfo2;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(3)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您通过我们的客服或参加我们举办的活动时所提交的信息，例如，您参与我们举办的活动时填写的申请单中可能包含您的姓名、电话、地址等信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l13 level1 lfo1;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">其他方使用广联达服务时所提供有关您的共享信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l13 level1 lfo1;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们在您使用服务时获取的信息：
          当您使用广联达服务时，我们可能会自动收集相关信息并存储为服务日志信息，如日志信息、位置信息、设备信息；也可能会基于产品改进，收集您的部分结果性数据（不含敏感信息），用于提升产品功能，以更好地为您服务。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l13 level1 lfo1;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>4．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">从第三方获取的信息，
          我们可能会获得您使用第三方服务所产生或分享的信息。例如，您使用第三方账户登录并使用广联达服务时，经过您同意，我们将获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息）。请您仔细阅读第三方服务的用户协议及
        </font>
        <font face="宋体">/或隐私政策。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l13 level1 lfo1;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>5．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">对于从您的各种设备上收集到的信息，
          我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、个性化内容和建议。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">（二）我们会出于以下目的，收集和使用您以下类型的个人信息：</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">帮助您完成注册及登录</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="text-indent:21.0000pt;mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;
mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">为便于我们为您提供服务，您需要提供基本注册或登录信息，创建您的账号、用户名和密码。在部分单项服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为广联达用户及提供上述信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal align=justify style="text-indent:21.0000pt;mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;
mso-pagination:none;text-align:justify;text-justify:inter-ideograph;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您可以自行登录</font>
        <font face="宋体">
          account.glodon.com，修改或完善您的其他资料，包括姓名、性别、生日、工作单位、头像照片、联系地址、联系人、手机号码等信息。但如果您不提供这些信息，并不会影响您使用广联达服务的基本功能，如您填写补充相关信息后视为您主动授权我们收集您的该类信息。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">向您提供产品或服务</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="mso-para-margin-left:2.0000gd;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们所收集和使用的个人信息是为您提供广联达服务的必要条件，如缺少相关信息，我们将无法为您提供广联达服务的核心内容，例如：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您在使用广联达服务时、上传和</font>
        <font face="宋体">/或发布信息以及进行相关行为（例如发布跟贴、回复跟贴、顶贴、分享、收藏）时，我们将收集您上传、发布或形成的信息，并有权展示您的昵称、头像和发布内容；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">在部分服务项目中，为便于向您交付产品或服务，您将需提供收货人姓名、地址、收货人、联系电话、支付状态等信息。如果您拒绝提供此类信息，我们将无法完成相关交付服务。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(3)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          当您需要我们提供特定的服务时，我们可能需要您提供必要的个人信息。例如，如果您更进一步了解我们的产品、成为我们的合作伙伴或了解更多信息，您可提供您的姓名、电子邮件地址、电话号码、国家、部门和职位、公司名称等信息，以确保我们能够与您联系并向您发送有关我们产品和服务的信息。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(4)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">为展示您账户的订单信息，我们会收集您在使用广联达服务过程中产生的订单信息用于向您展示及便于您对订单进行管理；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(5)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">当您联系我们的客服或要求我们响应服务时，我们可能需要您提供必要的个人信息以匹配并核验您的身份</font>
        <font face="宋体">，以便保障您的账号及系统安全。我们可能还会保存您的通信</font>
        <font face="宋体">/通话记录和内容或您留下的联系方式等信息， 以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(6)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">为向您提供更契合您需求的页面展示和推荐个性化内容、了解产品适配性、识别账号异常状态，我们可能会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:2.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226;
          日志信息：当您使用我们的服务时，我们可能会自动收集您对我们服务的详细使用情况，作为有关服务日志保存例如您的功能点击频次、打开工程次数、软件操作步骤、界面尺寸大小（用户调整我们提供的窗口界面大小）、功能复选框勾选状态、错误提示弹窗、新建构件参数图的选择数据、构件属性修改值的记忆、产品使用时长、产品启动频次、IP地址、浏览器的类型、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、Push打开记录、停留时长、刷新记录、发布记录及分享。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:2.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226;
          设备信息：我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如IMEI、MAC、Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、运营商名称、包名、设备设置、进程及软件列表、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息）。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:2.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">请注意，单独的设备信息、日志信息等无法识别特定自然人身份。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;mso-list:l15 level1 lfo4;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(7)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们通过间接方式收集到的您的个人信息：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:2.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
text-align:left;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          基于合法事由我们可能从关联方、第三方合作伙伴获取您授权共享的相关信息。例如，我们可能从第三方获取您授权共享的账户信息（包括用户名、头像、昵称）并在您同意本政策后将您的第三方账户与您的广联达服务账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与
        </font>
        <font face="宋体">/或服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的信息来源合法的前提下，收集并使用您的这些信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">向您提供产品或服务的信息展示和推送</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l14 level1 lfo5;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          为您展示和推送产品或服务。我们可能使用您的信息（例如您的日志信息、设备信息、位置信息、订单信息），用于提取您的偏好、行为习惯、位置信息相关特征，并基于特征标签通过电子邮件、短信或其他方式向您发送营销信息，提供或推广我们或第三方的产品和服务。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l14 level1 lfo5;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-right:0.0000pt;mso-para-margin-right:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          如您不希望继续接收我们推送的消息，您可要求我们停止推送，例如：根据短信退订指引要求我们停止发送推广短信，或在移动端设备中进行设置，不再接收我们推送的消息；但我们依法律规定或单项服务的服务协议约定发送消息的情形除外。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>4．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">评估、改进我们的服务</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们可能让您参与有关广联达服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>5．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">其他用途</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          请您注意，如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。一旦您同意，该等额外用途将视为本政策的一部分，该等额外信息也将适用本政策。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>6．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">征得授权同意的例外</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">与国家安全、国防安全有关的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">与公共安全、公共卫生、重大公共利益有关的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(3)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">与犯罪侦查、起诉、审判和判决执行等有关的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(4)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(5)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">所收集的信息是您自行向社会公众公开的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(6)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(7)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">根据您的要求或您所属企业签订和履行合同所必需的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(8)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">用于维护广联达服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(9)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">为合法的新闻报道所必需的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(10)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l7 level1 lfo6;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(11)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">法律法规规定的其他情形。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>7．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您理解并同意，部分单项服务可能需要您在您的设备中开启特定的访问权限（例如您的位置信息、摄像头、相册、麦克风、通讯录及</font>
        <font face="宋体">
          /或日历），以实现这些权限所涉及信息的收集和使用。当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>8．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">有关个人敏感信息的提示</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          以上由您提供或我们收集您的信息中，可能包含您的个人敏感信息，例如身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、征信信息、行踪轨迹、交易信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本政策所述的目的和方式来处理。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们不收集任何关于您的特殊类别的敏感个人信息（包括您的种族或族裔、宗教或哲学信仰、性取向、政治观点、您的健康信息以及遗传和生物特征数据）。我们也不收集任何有关刑事定罪和犯罪的信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l6 level1 lfo3;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>9．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您个人信息使用的规则</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l2 level1 lfo7;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们会根据本隐私政策的约定并为实现我们的产品与</font>
        <font face="宋体">/或服务功能对所收集的个人信息进行使用。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l2 level1 lfo7;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l2 level1 lfo7;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(3)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">请您注意，您在使用我们的服务时所提供的所有个人信息，除非您删除，否则将在您使用我们的产品与</font>
        <font face="宋体">/或服务期间持续授权我们使用。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l2 level1 lfo7;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(4)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们会对我们的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l2 level1 lfo7;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(5)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">二、我们如何使用</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:Arial;mso-fareast-font-family:黑体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">COOKIESS</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">或同类技术</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们可能通过</font>
        <font face="宋体">COOKIESS或同类技术获取和使用您的信息，并将该等信息储存为日志信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          COOKIES和匿名标示符等工具。COOKIES主要的功能是便于您使用网站产品和/或服务，以及帮助网站统计独立访客数量等。运用COOKIES技术广联达能够为您提供更加周到的个性化服务，并允许您设定您特定的服务选项。我们使用自己的COOKIESS或同类技术，可能用于以下用途：
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l12 level1 lfo8;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">帮助您获得更轻松的访问体验。例如：</font>
        <font face="宋体">COOKIESS或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l12 level1 lfo8;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">分析您使用我们服务的情况。我们可利用</font>
        <font face="宋体">COOKIESS或同类技术来了解您使用广联达服务进行什么操作、或哪些功能、服务最受欢迎；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l12 level1 lfo8;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">为您推荐、展示、推送您可能感兴趣的内容。我们可能会利用</font>
        <font face="宋体">COOKIES 和同类技术了解您的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的信息或功能。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l12 level1 lfo8;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>4．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您可以通过浏览器或用户选择机制拒绝或管理</font>
        <font face="宋体">COOKIESS或同类技术。但请您注意，如果您停用COOKIESS或同类技术，您可能无法使用依赖于COOKIESS或同类技术的服务。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">三、我们可能共享、转让或披露的个人信息</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">（一）共享</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们遵照法律法规的规定，对信息的共享进行严格的限制。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l16 level1 lfo9;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">经您事先同意，我们可能与第三方分享您的个人信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l16 level1 lfo9;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">除非您明确授权，
          我们不会向合作伙伴共享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址）。当我们需要向第三方合作伙伴分享已经匿名化或去标识化处理后的信息，将要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l16 level1 lfo9;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">随着我们业务的持续发展，
          当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l16 level1 lfo9;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>4．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们会将所收集到的信息用于大数据分析。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">（二）披露</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们可能基于以下目的披露您的个人信息：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226; 遵守适用的法律法规等有关规定；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226; 遵守法院判决、裁定或其他法律程序的规定；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226; 遵守相关政府机关或其他法定授权组织的要求；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226; 我们有理由确信需要遵守法律法规等有关规定；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">&#8226; 为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">四、我们如何储存和保护个人信息</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们仅在本政策所述目的所必需期间和法律法规要求的最短时限内储存您的个人信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="text-indent:21.0000pt;mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;
mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们在中华人民共和国境内运营中收集和产生的个人信息，储存在中国境内，以下情形除外：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l1 level1 lfo10;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">法律法规有明确规定；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l1 level1 lfo10;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">获得您的授权同意；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l1 level1 lfo10;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您使用的产品、服务涉及跨境，广联达依法向境外提供您的个人信息的。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们非常重视信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l4 level1 lfo11;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">数据安全技术措施</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。</font> &nbsp;&nbsp;&nbsp;
        <font face="宋体">广联达通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们的服务采取了多种加密技术，例如在某些产品中，我们将利用加密技术（例如</font>
        <font face="宋体">SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">在个人信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中的安全性。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们还会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l4 level1 lfo11;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们会采取一切合理可行的措施，确保未收集无关的个人信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l4 level1 lfo11;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(3)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l4 level1 lfo11;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(4)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致个人信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l4 level1 lfo11;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(5)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">安全事件处置</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">在通过广联达服务与第三方进行沟通或购买产品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入广联达服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          请您务必妥善保管好您的账号、密码及其他身份要素。您在使用广联达服务时，我们会通过您的账号、密码及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现账号、密码及</font>
        <font face="宋体">/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">五、如何管理您的个人信息</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          我们非常重视您对个人信息的管理，并尽全力保护对您个人信息的查阅、复制、更正、补充、删除、撤回同意授权、注销帐号、投诉举报的相关权利，以使您有能力保障您的隐私和信息安全。为了优化您的使用体验，我们也可能对操作设置进行调整，故如下指引仅供参考。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您有权请求访问您的信息，或者要求查阅、复制您的个人信息</font>
        <font face="宋体">;</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如果您发现您的信息不准确或不完整，您有权请求更新或修改、补充您的信息，但您在提出要求更正、补充个人信息时，我们将会要求您对您的个人信息进行核实确认，并及时根据您核实确认的结果进行更正、补充；
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">因与您有关的特定理由，您有权反对您的信息的某些使用（包括直接营销，数据画像，基于合法利益的处理，以及用于科学或历史研究和统计的处理）；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>4．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">在以下情况下，我们会主动删除您的信息或者您有权要求删除您的信息或限制信息的使用：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如果我们处理个人信息的行为违反法律法规；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如果我们收集、使用您的个人信息，却未征得您的同意；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(3)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如果我们处理个人信息的行为违反了与您的约定；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(4)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">处理您信息目的已经实现、无法实现或者不再必要；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(5)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们停止了向您提供产品或者服务；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(6)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们对使用并保存您的信息的保存期限已经届满；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(7)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您撤回您的授权同意行为；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l8 level1 lfo13;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(8)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">法律、行政法规规定的其他情形。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>5．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">提出请求的方式与渠道</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l11 level1 lfo14;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(1)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您如果提供本款</font>
        <font face="宋体">
          1-4项内容的处理，您必须以书面形式或者按照广联达网站或者具体产品中的提示路径进行手动操作。如果您通过其他渠道提出相关请求，我们会引导您通过目前可留痕的前述渠道提出正式诉求，以便于交流和反馈处理进度及结果。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:-0.2500pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-autospace:ideograph-numeric;mso-pagination:none;
line-height:150%;mso-list:l11 level1 lfo14;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>(2)</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          您在提出相应的诉求要求时，我们需要您提供足够的信息（包括但不限于您注册时候注册手机验证码、注册邮箱验证码，或者在前述均无的情况下，需要您提供您的其他有效身份信息）来验证您的身份，确保相关诉求确由您本人发出。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>6．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>7．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">注销</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          在符合广联达单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项广联达服务帐号可能被注销或删除。您可在广联达官网登陆账号后，或者在相关设备、应用程序中登录广联达帐号后，在相应界面中提交注销申请并完成注销。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">当帐号注销或被删除后，我们将停止为您提供产品及或服务，除法律法规另有规定外，我们将删除您的个人信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">请您知悉，账户一旦被注销将不可恢复，请您在操作之前自行备份账户相关的所有信息和数据。注销账户后，您将无法再使用本账户，也将无法找回您账户中及与账户相关的任何内容或信息。若您想再次享受相关的产品与
        </font>
        <font face="宋体">/服务，您需要重新注册帐号。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal align=justify style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;text-align:justify;text-justify:inter-ideograph;
line-height:150%;mso-list:l0 level1 lfo12;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>8．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">改变或撤回您授权同意的范围</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您可以通过删除信息、关闭设备功能、在广联达官网或者相关设备进行隐私设置等方式改变您授权我们继续收集个人</font>
        <font face="宋体">信息的范围或撤回您的授权。在广联达账号相关业务中，您也可以通过注销账号的方式，撤回我们通过广联达账号相关业务继续收集您个人信息的全部授权。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          请您理解并知悉，广联达每个业务功能或者产品可能不同程度需要一些必要的个人信息才能得以完成，但大多数其他信息的提供由您决定。当您撤回同意或授权后，我们无法继续为您提供依赖于您同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如何在具体产品和服务中撤回同意，由广联达在该具体产品或服务的专门的隐私协议中发布。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">六、第三方服务</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">广联达服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l3 level1 lfo15;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您可利用</font>
        <font face="宋体">“分享”键将某些内容分享到第三方服务，或您可利用第三方服务登录广联达服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的电脑装置COOKIESS，从而正常运行上述功能；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l3 level1 lfo15;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们通过广告或我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l3 level1 lfo15;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们可能会接入第三方</font>
        <font face="宋体">SDK服务，并将我们依照本政策收集的您的某些个人信息共享给该等第三方，以便提供更好的客户服务和用户体验。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          该等第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">七、我们对未成年人的政策</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">为了保护未成年人的隐私和安全，我们对未成年人的个人信息提供了具体的保护。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们不对</font>
        <font face="宋体">14周岁以下的未成年人提供产品或服务，并且我们不会故意或在明确知道的情况下收集未成年的个人信息。基于我们产品功能的专业性和复杂性，我们推定您具有相应的民事行为能力。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如果您未满</font>
        <font face="宋体">14周岁，我们要求您请您的父母或其他监护人仔细阅读本政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">一旦</font>
        <font face="宋体">14周岁以下的未成年人全部或部分下载、安装或使用我们的任何服务，其下载、安装或使用我们的任何服务的行为即视为其父母或其他监护人同意我们的政策，条款和条件，包括但不限于本隐私政策。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">八、通知和修订</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">
          为了给您提供更好的服务，我们可能会根据产品或服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。如该等更新造成您在本政策下权利的实质减少或重大变更，我们将在本政策生效前通过网站公告、推送通知、弹窗提示或其他方式来通知您，您如果不同意该等变更，可以选择停止使用广联达服务；如您仍然继续使用广联达服务的，即表示您已充分阅读、理解并同意受经修订的本政策的约束。
        </font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">本政策所指的重大变更包括但不限于：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l9 level1 lfo16;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">产品及服务的业务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l9 level1 lfo16;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l9 level1 lfo16;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>3．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">个人信息共享或公开披露的主要对象发生变化；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l9 level1 lfo16;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>4．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">用户个人信息权利及其行使方式发生重大变化；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l9 level1 lfo16;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>5．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">处理个人信息保护负责人的联络方式及投诉渠道发生变化时；</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l9 level1 lfo16;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>6．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">个人信息保护影响评估报告表明产品存在对个人权益有重大影响时。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们的任何修改都会将您的满意度置于首位。我们鼓励您在每次使用广联达服务时都查阅我们的隐私政策。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">九、适用法律与争议解决</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l10 level1 lfo17;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>1．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">适用法律</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">本政策的执行、解释及争议的解决均适用中华人民共和国法律，且不考虑任何冲突法。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;mso-para-margin-left:0.0000gd;text-indent:21.0000pt;
mso-char-indent-count:2.0000;line-height:150%;mso-list:l10 level1 lfo17;">
      <![if !supportLists]><span style="font-family:'Times New Roman';mso-fareast-font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;"><span style='mso-list:Ignore;'>2．</span></span>
      <![endif]><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">争议解决</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span>
    </p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">您和我们的产品与</font>
        <font face="宋体">/或服务就本政策内容或其执行发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，双方同意应将争议提交至被告住所地人民法院裁决。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <h6><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-hansi-font-family:宋体;
mso-ansi-font-weight:bold;mso-bidi-font-weight:normal;font-size:12.0000pt;
mso-font-kerning:1.0000pt;">
          <font face="黑体">十、如何联系我们</font>
        </span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:黑体;mso-ascii-font-family:Arial;
mso-hansi-font-family:Arial;mso-bidi-font-family:'Times New Roman';mso-ansi-font-weight:bold;
mso-bidi-font-weight:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;">
          <o:p></o:p>
        </span></b></h6>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
text-autospace:ideograph-numeric;mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如果您对本隐私政策或我们的隐私措施有任何疑问，请通过以下方式与我们联系：</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
text-autospace:ideograph-numeric;mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">公司全名：广联达科技股份有限公司</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
text-autospace:ideograph-numeric;mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">邮箱地址：</font>
      </span><span><u><span class="17" style="mso-spacerun:'yes';font-family:宋体;
text-decoration:underline;text-underline:single;">
            <font face="宋体">G-data-security@glodon.com</font>
          </span></u></span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
text-autospace:ideograph-numeric;mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">如有关售后服务问题请直接联系：</font>
        <font face="宋体">4000-166-166</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
text-autospace:ideograph-numeric;mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">邮寄地址：北京市海淀区东北旺西路</font>
        <font face="宋体">10号院中关村软件园13号楼广联达信息大厦</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal style="margin-left:0.0000pt;text-indent:21.0000pt;mso-char-indent-count:2.0000;
text-autospace:ideograph-numeric;mso-pagination:none;line-height:150%;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <font face="宋体">一般情况下，我们将在收到您的问题、意见或建议，并验证您的身份后的十五天内予以回复。</font>
      </span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
    <p class=MsoNormal><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:10.5000pt;
mso-font-kerning:1.0000pt;">
        <o:p></o:p>
      </span></p>
  </div>
</template>
<script>
export default {
  name: "Service1",
};
</script>
<style scoped>
.service {
  background-color: rgb(255, 255, 255);
  width: 100%;
  padding: 20px 100px;
}

@font-face {
  font-family: "Times New Roman";
}

@font-face {
  font-family: "宋体";
}

@font-face {
  font-family: "Wingdings";
}

@font-face {
  font-family: "等线";
}

@font-face {
  font-family: "Arial";
}

@font-face {
  font-family: "黑体";
}

@list l0:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l0:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l1:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 21.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l2:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l2:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l3:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 42.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l4:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l4:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 42.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l5:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l5:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l6:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 21.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l7:level2 {
  mso-level-number-format: decimal-enclosed-circle-chinese;
  mso-level-suffix: tab;
  mso-level-text: "%2";
  mso-level-tab-stop: 42.0000pt;
  mso-level-number-position: left;
  margin-left: 42.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3)";
  mso-level-tab-stop: 63.0000pt;
  mso-level-number-position: left;
  margin-left: 63.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level4 {
  mso-level-number-format: alpha-lower;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 84.0000pt;
  mso-level-number-position: left;
  margin-left: 84.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level5 {
  mso-level-number-format: alpha-lower;
  mso-level-suffix: tab;
  mso-level-text: "%5)";
  mso-level-tab-stop: 105.0000pt;
  mso-level-number-position: left;
  margin-left: 105.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level6 {
  mso-level-number-format: lower-roman;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 126.0000pt;
  mso-level-number-position: left;
  margin-left: 126.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level7 {
  mso-level-number-format: lower-roman;
  mso-level-suffix: tab;
  mso-level-text: "%7)";
  mso-level-tab-stop: 147.0000pt;
  mso-level-number-position: left;
  margin-left: 147.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level8 {
  mso-level-number-format: alpha-lower;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 168.0000pt;
  mso-level-number-position: left;
  margin-left: 168.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l7:level9 {
  mso-level-number-format: alpha-lower;
  mso-level-suffix: tab;
  mso-level-text: "%9)";
  mso-level-tab-stop: 189.0000pt;
  mso-level-number-position: left;
  margin-left: 189.0000pt;
  text-indent: -21.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 42.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l8:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 93.0000pt;
  mso-level-number-position: left;
  margin-left: 93.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 129.0000pt;
  mso-level-number-position: left;
  margin-left: 129.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 165.0000pt;
  mso-level-number-position: left;
  margin-left: 165.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 201.0000pt;
  mso-level-number-position: left;
  margin-left: 201.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 237.0000pt;
  mso-level-number-position: left;
  margin-left: 237.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 273.0000pt;
  mso-level-number-position: left;
  margin-left: 273.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 309.0000pt;
  mso-level-number-position: left;
  margin-left: 309.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l8:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 345.0000pt;
  mso-level-number-position: left;
  margin-left: 345.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l9:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l10:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 42.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l11:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 93.0000pt;
  mso-level-number-position: left;
  margin-left: 93.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 129.0000pt;
  mso-level-number-position: left;
  margin-left: 129.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 165.0000pt;
  mso-level-number-position: left;
  margin-left: 165.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 201.0000pt;
  mso-level-number-position: left;
  margin-left: 201.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 237.0000pt;
  mso-level-number-position: left;
  margin-left: 237.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 273.0000pt;
  mso-level-number-position: left;
  margin-left: 273.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 309.0000pt;
  mso-level-number-position: left;
  margin-left: 309.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l11:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 345.0000pt;
  mso-level-number-position: left;
  margin-left: 345.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l12:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l13:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 21.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l14:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l14:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "(%1)";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.2500pt;
  text-indent: -21.2500pt;
  font-family: 'Times New Roman';
}

@list l15:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l15:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level1 {
  mso-level-number-format: decimal;
  mso-level-suffix: none;
  mso-level-text: "%1．";
  mso-level-tab-stop: 0.0000pt;
  mso-level-number-position: left;
  margin-left: 0.0000pt;
  text-indent: 20.0000pt;
  margin-left: 0.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level2 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%2.";
  mso-level-tab-stop: 72.0000pt;
  mso-level-number-position: left;
  margin-left: 72.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level3 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%3.";
  mso-level-tab-stop: 108.0000pt;
  mso-level-number-position: left;
  margin-left: 108.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level4 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%4.";
  mso-level-tab-stop: 144.0000pt;
  mso-level-number-position: left;
  margin-left: 144.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level5 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%5.";
  mso-level-tab-stop: 180.0000pt;
  mso-level-number-position: left;
  margin-left: 180.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level6 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%6.";
  mso-level-tab-stop: 216.0000pt;
  mso-level-number-position: left;
  margin-left: 216.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level7 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%7.";
  mso-level-tab-stop: 252.0000pt;
  mso-level-number-position: left;
  margin-left: 252.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level8 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%8.";
  mso-level-tab-stop: 288.0000pt;
  mso-level-number-position: left;
  margin-left: 288.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

@list l16:level9 {
  mso-level-number-format: decimal;
  mso-level-suffix: tab;
  mso-level-text: "%9.";
  mso-level-tab-stop: 324.0000pt;
  mso-level-number-position: left;
  margin-left: 324.0000pt;
  text-indent: -18.0000pt;
  font-family: 'Times New Roman';
}

p.MsoNormal {
  mso-style-name: 正文;
  mso-style-noshow: yes;
  mso-style-parent: "";
  margin-top: 0.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 0.0000pt;
  margin-left: 0.0000pt;
  mso-pagination: none;
  text-align: justify;
  text-justify: inter-ideograph;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

h1 {
  mso-style-name: "标题 1";
  mso-style-next: 正文;
  margin-top: 17.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 16.5000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 1;
  line-height: 240%;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 22.0000pt;
  mso-font-kerning: 22.0000pt;
}

h2 {
  mso-style-name: "标题 2";
  mso-style-next: 正文;
  margin-top: 13.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 13.0000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 2;
  line-height: 171%;
  font-family: Arial;
  mso-fareast-font-family: 黑体;
  mso-bidi-font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 16.0000pt;
  mso-font-kerning: 1.0000pt;
}

h3 {
  mso-style-name: "标题 3";
  mso-style-next: 正文;
  margin-top: 13.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 13.0000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 3;
  line-height: 171%;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 16.0000pt;
  mso-font-kerning: 1.0000pt;
}

h4 {
  mso-style-name: "标题 4";
  mso-style-next: 正文;
  margin-top: 14.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 14.5000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 4;
  line-height: 155%;
  font-family: Arial;
  mso-fareast-font-family: 黑体;
  mso-bidi-font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 14.0000pt;
  mso-font-kerning: 1.0000pt;
}

h5 {
  mso-style-name: "标题 5";
  mso-style-next: 正文;
  margin-top: 14.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 14.5000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 5;
  line-height: 155%;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 14.0000pt;
  mso-font-kerning: 1.0000pt;
}

h6 {
  mso-style-name: "标题 6";
  mso-style-next: 正文;
  margin-top: 12.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 3.2000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 6;
  line-height: 131%;
  font-family: Arial;
  mso-fareast-font-family: 黑体;
  mso-bidi-font-family: 'Times New Roman';
  font-weight: bold;
  font-size: 12.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoHeading7 {
  mso-style-name: "标题 7";
  mso-style-next: 正文;
  margin-top: 12.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 3.2000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 7;
  line-height: 131%;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  mso-ansi-font-weight: bold;
  font-size: 12.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoHeading8 {
  mso-style-name: "标题 8";
  mso-style-next: 正文;
  margin-top: 12.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 3.2000pt;
  margin-left: 0.0000pt;
  mso-para-margin-top: 0.0000gd;
  mso-para-margin-bottom: 0.0000gd;
  page-break-after: avoid;
  mso-pagination: lines-together;
  text-align: justify;
  text-justify: inter-ideograph;
  mso-outline-level: 8;
  line-height: 131%;
  font-family: Arial;
  mso-fareast-font-family: 黑体;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 12.0000pt;
  mso-font-kerning: 1.0000pt;
}

span.10 {
  font-family: 'Times New Roman';
}

span.15 {
  font-family: 'Times New Roman';
}

span.16 {
  font-family: 'Times New Roman';
  font-size: 10.5000pt;
}

span.17 {
  font-family: 'Times New Roman';
  color: rgb(0, 0, 255);
  text-decoration: underline;
  text-underline: single;
}

span.18 {
  font-family: 'Times New Roman';
  font-size: 9.0000pt;
}

span.19 {
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 9.0000pt;
  mso-font-kerning: 1.0000pt;
}

span.20 {
  font-family: 'Times New Roman';
  color: rgb(0, 0, 255);
  text-decoration: underline;
  text-underline: single;
}

span.21 {
  font-family: 'Times New Roman';
  font-size: 9.0000pt;
}

p.22 {
  mso-style-name: "普通\(网站\) Char";
  margin-top: 5.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 5.0000pt;
  margin-left: 0.0000pt;
  mso-margin-top-alt: auto;
  mso-margin-bottom-alt: auto;
  mso-pagination: widow-orphan;
  text-align: left;
  font-family: 宋体;
  font-size: 12.0000pt;
}

p.pre {
  mso-style-name: "HTML 预设格式";
  margin-top: 0.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 0.0000pt;
  margin-left: 0.0000pt;
  mso-pagination: widow-orphan;
  text-align: left;
  font-family: 宋体;
  font-size: 12.0000pt;
}

p.MsoCommentText {
  mso-style-name: 批注文字;
  margin-top: 0.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 0.0000pt;
  margin-left: 0.0000pt;
  mso-pagination: none;
  text-align: left;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 10.5000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoAcetate {
  mso-style-name: 批注框文本;
  margin-top: 0.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 0.0000pt;
  margin-left: 0.0000pt;
  mso-pagination: none;
  text-align: justify;
  text-justify: inter-ideograph;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 9.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoFooter {
  mso-style-name: 页脚;
  margin-top: 0.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 0.0000pt;
  margin-left: 0.0000pt;
  layout-grid-mode: char;
  mso-pagination: none;
  text-align: left;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 9.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.MsoHeader {
  mso-style-name: 页眉;
  margin-top: 0.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 0.0000pt;
  margin-left: 0.0000pt;
  border-bottom: 1.0000pt solid windowtext;
  mso-border-bottom-alt: 0.7500pt solid windowtext;
  padding: 0pt 0pt 1pt 0pt;
  layout-grid-mode: char;
  mso-pagination: none;
  text-align: center;
  font-family: 等线;
  mso-bidi-font-family: 'Times New Roman';
  font-size: 9.0000pt;
  mso-font-kerning: 1.0000pt;
}

p.p {
  mso-style-name: "普通\(网站\)";
  margin-top: 5.0000pt;
  margin-right: 0.0000pt;
  margin-bottom: 5.0000pt;
  margin-left: 0.0000pt;
  mso-margin-top-alt: auto;
  mso-margin-bottom-alt: auto;
  mso-pagination: widow-orphan;
  text-align: left;
  font-family: 宋体;
  font-size: 12.0000pt;
}

span.msoIns {
  mso-style-type: export-only;
  mso-style-name: "";
  text-decoration: underline;
  text-underline: single;
  color: blue;
}

span.msoDel {
  mso-style-type: export-only;
  mso-style-name: "";
  text-decoration: line-through;
  color: red;
}

table.MsoNormalTable {
  mso-style-name: 普通表格;
  mso-style-parent: "";
  mso-style-noshow: yes;
  mso-tstyle-rowband-size: 0;
  mso-tstyle-colband-size: 0;
  mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
  mso-para-margin: 0pt;
  mso-para-margin-bottom: .0001pt;
  mso-pagination: widow-orphan;
  font-family: 'Times New Roman';
  font-size: 10.0000pt;
  mso-ansi-language: #0400;
  mso-fareast-language: #0400;
  mso-bidi-language: #0400;
}

@page {
  mso-page-border-surround-header: no;
  mso-page-border-surround-footer: no;
}

@page Section0 {
  margin-top: 72.0000pt;
  margin-bottom: 72.0000pt;
  margin-left: 90.0000pt;
  margin-right: 90.0000pt;
  size: 595.3000pt 841.9000pt;
  layout-grid: 15.6000pt;
  mso-header-margin: 42.5500pt;
  mso-footer-margin: 49.6000pt;
}

/* .service p {
  text-indent: 2em;
} */
</style>